// extracted by mini-css-extract-plugin
module.exports = {"hint":"Quiz_hint__IWAad","item":"Quiz_item__1kNZU","reset":"Quiz_reset__2RCFJ"};